import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import axios from 'axios'
import Vuelidate from 'vuelidate'
import moment from 'moment'
import i18n from './plugins/i18n'
import store from './store'
import router from './router'
import * as filters from '@/helpers/filters'
import '@/helpers/stringExtension'

Vue.use(Vuelidate)

Vue.config.productionTip = true

Vue.prototype.$axios = axios

Vue.prototype.moment = moment

// filters
Object.keys(filters).forEach((key: string) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Vue.filter(key, (filters as any)[key])
})

new Vue({
  i18n,
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
